import type { ReactElement } from 'react';
import './LoaderVariant1.css';

export function LoaderVariant1(): ReactElement {
  return <div className="lv1" />;
}
